import {
  all, put, takeEvery, call,
} from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import Auth from '@aws-amplify/auth';
import { FORM_NAME, SUCCESS_MESSAGE } from 'domain/accountAdmins/components/create/constants';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { getTokens } from 'domain/accountAdmins/components/create/model';

import { ROUTES as ACCOUNT_ADMINS_ROUTES, ACCOUNT_TYPE } from 'domain/accountAdmins/constants';
import * as api from './api';
import { formatSignUpRequest, getPostData, getAccountData } from './utils';

function* createAccountAdmin(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));

  const {
    payload: { values },
  } = action;

  const { email, password, companyCode } = values;

  try {
    if (companyCode) {
      const resp = yield call(api.checkCompanyCode, companyCode);

      if (resp) {
        throw new Error('companyCodeExist');
      }
    }
    yield put(startSubmit(FORM_NAME));
    try {
      const response = yield Auth.signUp(formatSignUpRequest(values));
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }
    const tokens = yield login({ email, password });

    const postData = getPostData(values);
    const headers = {
      Authorization: `Bearer ${tokens.idToken}`,
    };

    try {
      yield call(api.createUser, {
        userInfo: postData,
        type: ACCOUNT_TYPE,
        headers,
      });

      const accountData = getAccountData(values);

      yield call(api.createAccount, {
        accountInfo: accountData,
        type: ACCOUNT_TYPE,
        headers,
      });

      yield put(stopSubmit(FORM_NAME));
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }

    yield put(reset(FORM_NAME));
    yield put(showNotification(SUCCESS_MESSAGE, 'success'));
    setTimeout(() => {
      context.history.push(ACCOUNT_ADMINS_ROUTES.ROOT);
    }, 2000);
  } catch (e) {
    console.error(e);
    yield put(showNotification(e.message, 'error'));
    yield put(stopSubmit(FORM_NAME));
  }
}
function* login({ email, password }) {
  try {
    const data = {
      clientId: AWS_USER_POOL_WEB_CLIENT_ID,
      domain: SYSTEM_DOMAIN,
      password,
      username: email,
    };
    const resp = yield call(api.signIn, data);

    const tokens = getTokens(resp);

    return tokens;
  } catch (e) {
    throw new Error(e.message);
  }
}
function* watcher(context) {
  yield all([takeEvery(doSubmit().type, createAccountAdmin, context)]);
}

export default watcher;
